import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchCulpritPartOneVehicleInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPartOneVehicleInformation/patchCulpritPartOneVehicleInformationFunction';
import { PatchCulpritPartOneVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPartOneVehicleInformation/patchCulpritPartOneVehicleInformation.type';
import { VehicleInformationEnum } from '@/modules/adjusterReportModules/IncidentParticipants/types/VehicleInformationType';
import { patchInitialPartOneVehicleInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPartOneVehicleInformation/patchCulpritPartOneInitialInformationFunction';

export const PatchCulpritPartOneVehicleInformationOption = (
  type: VehicleInformationEnum,
): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchCulpritPartOneVehicleInformationType
> => ({
  mutationKey: ['patch-culprit_part_one-vehicle-information'],
  mutationFn: ({ id, data }: PatchCulpritPartOneVehicleInformationType) =>
    type === VehicleInformationEnum.culprit
      ? patchCulpritPartOneVehicleInformationFunction({ data, id })
      : patchInitialPartOneVehicleInformationFunction({ data, id }),
});
